module.exports = __webpack_public_path__ + "img/default-user.59a8f5be.png";